import Axios from "./index";
import { parseFilters } from "./helper";

export const indexSingles = params => {
  return Axios.get(`/user/sound_tracks`, { params: parseFilters(params) });
};

export const removeMediumFromSingle = (medium_id) => {
  return Axios.delete(
    `/user/sound_tracks/${medium_id}`
  );
};

export const latestReleases = params => {
  return Axios.get(
    `/user/sound_tracks/latest_release`, { params: parseFilters(params) }
  );
};
